// CRYPTO_SECRET_KEY removed for security - use environment variables
export const PER_PAGE_LIST = 12;

export const DOB_MONTHS = [
  { value: 1, label: "January" },
  { value: 2, label: "February" },
  { value: 3, label: "March" },
  { value: 4, label: "April" },
  { value: 5, label: "May" },
  { value: 6, label: "June" },
  { value: 7, label: "July" },
  { value: 8, label: "August" },
  { value: 9, label: "September" },
  { value: 10, label: "October" },
  { value: 11, label: "November" },
  { value: 12, label: "December" },
];

export const YES_NO_RADIO = [
  {
    label: "No",
    value: "no",
  },
  {
    label: "Yes",
    value: "yes",
  },
];

export const GENDER_RADIO = [
  {
    label: "Male",
    value: "male",
  },
  {
    label: "Female",
    value: "female",
  },
  {
    label: "Other",
    value: "other",
  },
];

export const PROFILE_IMAGE_ASPECT_RATIO = 1;

export const CUSTOM_MESSAGE = {
  SEND_OTP: "6 digit OTP has been sent successfully",
  RESENT_OTP: "OTP Resent successfully.",
};

export const REFERRAL_SOURCE_MAPPING: { [key: string]: string } = {
  google: "google",
  "social-media": "facebook", // Map social media to facebook as closest match
  referral: "friend", // Map referral to friend as closest match
  advertisement: "other", // Map advertisement to other
  other: "other",
};

export const HOW_DID_YOU_HEAR_OPTIONS = [
  { value: "", label: "Select --" },
  { value: "google", label: "Google Search" },
  { value: "social-media", label: "Social Media" },
  { value: "referral", label: "Referral" },
  { value: "advertisement", label: "Advertisement" },
  { value: "other", label: "Other" },
];

export const SOCKET_CHANNEL = {
  ENTITY_ACTIVITY: "rgEntityActivity",
  // TV_BOARD_IMAGE: "irTvBoardEmit",
  // ADV_PROMOTION: "adsPromotionInsideRodeo",
  // WINNER_TEXT: "irWinnerText",
  APP_REDIRECT: "appRedirect",
  STATUS_MSG: "siteStatusMsg",
  GLOW_EVENT: "irGlowEvent",
  COUPON: "irCoupon",
};

export const EVENT_MSG = {
  EVENT_NOT_STARTED: "Event not started yet!",
  EVENT_LIVE: "Event is Live!",
  EVENT_ENDED: "Event Ended!",
  EVENT_PAUSED: "Event was Paused!",
  EVENT_STARTED: "Let's Play! Click below to start!",
  GUESS_STARTED: "Guess Started!",
};

export const RODEO_PAGE_NAME = {
  DASHBOARD: "dashboard",
  LOGIN: "login",
  EVENT_LIST: "event_list",
  EVENT_GAME_LIST: "event_game_list",
  EVENT_GAME_DETAILS: "event_game_details",
  MY_ACCOUNT: "my_account",
  VIEW_PROFILE: "view_profile",
  EDIT_PROFILE: "edit_profile",
  ABOUT_US: "about_us",
  LEGAL: "legal",
  LEADERBOARD: "leaderboard",
  HOW_TO_PLAY: "how-to-play",
  TERM_OF_USE: "term-of-use",
  NOT_FOUND_PAGE: "not-found",
  CMS: "cms",
  LANDING: "landing",
  NEW_JOB_POSTING: "new-job-posting",
  AI_CANDIDATE_SEARCH: "ai-candidate-search",
  PREVIEW_JOB: "preview-job",
  JOB_DETAILS: "job-details",
  JOB_LISTINGS: "job-listings",
  MEMBERS: "members",
  ADD_MEMBER: "add-member",
  CANDIDATES: "candidates",
  NOTIFICATIONS: "notifications",
  SETTINGS_SECURITY: "settings-security",
  SETTINGS_SUBSCRIPTIONS: "settings-subscriptions",
  SETTINGS_BILLING: "settings-billing",
  SETTINGS_HISTORY: "settings-history",
  CONTACT_US: "contact-us",
};

export const MODAL_NAME = {
  NOTIFY_ME: "notify-me",
};

export const COMPANY_TYPES = [
  "Startup",
  "SME",
  "Enterprise",
  "Private Limited",
  "Public Limited",
  "Partnership",
  "Sole Proprietorship",
  "Government",
  "NGO",
  "Others",
];

export const CANDIDATE_STATUS = {
  REJECTED: 0,
  SCREENED: 1,
  SEND_AI_INTERVIEW: 2,
  SCHEDULE_INTERVIEW: 3,
  CANDIDATE_ACCEPT_VIA_MAIL: 4,
  CANDIDATE_REJECT_VIA_MAIL: 5,
  INTERVIEW_DONE: 6,
  FINAL_DECISION: 7,
  HIRED: 8,
  INTERVIEW_REJECTED: 9,
};

export const INTERVIEW_STATUS = {
  CANCEL: 0,
  INITIAL: 1,
  RESCHEDULE: 2,
  COMPLETE: 3,
};
